import React, { Component } from 'react';

import Section from './Section';

const RenaperIntroduction = ({ onFinish }) => {
  return (<div className='renaper-background'>
    <Section className="intro_form">
      <div className="row">
        <div className="pd-content-left col-md-5 col-lg-5 text-center" >
          <div className="header-img" >
            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
          </div>
          <div className="header-message">
            <h3><b>Validación de identidad.</b></h3>
          </div>
        </div>
        <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
          <div className="pvc-form">
            <div className="row">
              <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1">
                <span>
                  <div>
                    <p style={{
                      fontFamily: "Rubik,sans-serif!important",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "150%",
                    }}>
                      <b>Para validar tu identidad es necesario que tengas tu DNI a mano. Asegurate de estar en un lugar tranquilo y con buena luz.</b>
                    </p>
                  </div>
                  <p className='text-center' style={{
                    fontFamily: "Rubik,sans-serif!important",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "150%",
                  }}>
                    <i className="fa fa-check text-center" ariaHidden="true"></i> Validamos tu identidad
                  </p>
                  <p className='text-center' style={{
                    fontFamily: "Rubik,sans-serif!important",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "150%",
                  }}>
                    <i className="fa fa-check text-center" ariaHidden="true"></i> Escaneamos tu DNI
                  </p>
                  <p className='text-center' style={{
                    fontFamily: "Rubik,sans-serif!important",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "150%",
                  }}>
                    <i className="fa fa-check" ariaHidden="true"></i> Chequeamos tus datos
                  </p>
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                <button
                  type="submit"
                  className="btn btn-warning btn-lg pd-button pd-form"
                  onClick={(event) => {
                    event.preventDefault();
                    onFinish();
                  }}>
                  Entendido
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section >
  </div>
  )
}

module.exports = RenaperIntroduction;



/** WEBPACK FOOTER **
 ** ./src/components/RenaperIntroduction.js
 **/